import { Button, Stack, Table } from "react-bootstrap";
import { hideDialog, showDialog } from "../../support/modal_dialog";
import { modelStore } from "../storage/model";
import { access, ele, ToggleButton, useProperty } from "../../support/general";
import $ from "jquery"
import { sendCommand } from "../../support/LocalCommand";
import { onManageColumns } from "./Fields";
import { onNavLevel } from "./ENavigation";
import { repairSubscriptTree } from "../storage/changes";


// ToggleButton({value,text,size,keyId,onChange,className,style,selectedTextColor,textColor,backColor,selectedBackColor,borderColor})
export function MainMenu({scriptId,sideIsNav,focussedSubscriptId}) {

    var showFolder = modelStore.useSelector(state=>{
        return access(state,['model','showFolder']);
    });
    
    var showNavigation = modelStore.useSelector(state=>{
        return access(state,['model','showNavigation']);
    });

    function toggleFolder() {
        modelStore.dispatch(state=>{
            state.model.showFolder = !state.model.showFolder
        })
    }

    function toggleNavigation() {
        modelStore.dispatch(state=>{
            state.model.showNavigation = !state.model.showNavigation
        })
    }

    var focussedSubscriptName = modelStore.useSelector(state=>{
        return access(state,["model","Script",scriptId,"subscripts",focussedSubscriptId,"name"],"");
    },focussedSubscriptId);


    var isSending = modelStore.useSelector(state=>{
        return access(state,["isSending"],"");
    });
    
    function onDevelopmentReset(){
        sendCommand({
            action : {
                scriptId : scriptId,
                ownershipId : 1234,
                objectType : 'Script',
                verb : 'devReset',
                onSucceeded : result =>{
                    showDialog({
                        message : 'Successfully reset. Reload page.',
                        ok : true
                    })
                }
            },
        });
    }
    return (
        <Stack direction="horizontal" gap={3} style={{ padding:'0.5em'}}>
            <ToggleButton
                value = {showFolder}
                text = "Folder"
                onChange = {toggleFolder}
            />
            <ToggleButton
                value = {showNavigation}
                text = 'Navigation'
                 onChange = {toggleNavigation}
            />
            <Button className="" onClick={()=>onManageColumns(scriptId,focussedSubscriptId)} >Columns</Button>
            {/* <Button className="" onClick={onDevelopmentReset} >Dev Reset</Button> */}
            <Button className="" onClick={()=>onFinalDraft(scriptId,focussedSubscriptId)}>Final Draft</Button>
            <Button className="" onClick={()=>onNavLevel(scriptId,focussedSubscriptId)}>Nav Level</Button>
            {/* <Button className="" onClick={()=>repairSubscriptTree(scriptId)}>Remake Subscripts</Button> */}
            <span style={{fontSize : "1.5em"}}>{focussedSubscriptName}</span>
             <span style={{}}>{isSending?"(sending)":""}</span>
        </Stack>
    )
}

function onFinalDraft(scriptId,subscriptId){

    var blocks = [];

    $.each( modelStore.state.model.Block,(blockUid,block)=>{
        if (block.subscriptId==subscriptId && block.scriptId == scriptId){
            blocks.push(block);
        }
    });

    blocks.sort((a,b)=>a.ordering-b.ordering);

    var nextId = 1;

    var contentElements = [];
    $.each( blocks,(index,block)=>{
        
        // <Paragraph Type="New Act" id="1">
        //     <Text>New Act</Text>
        // </Paragraph>
        var paragraphType = {
            section : 'New Act',
            sequence  : 'Sequence',
            note : 'Note',
            scene : 'Scene Heading',
            action : 'Action',
            character : 'Character',
            dialog : 'Dialogue',
            parenthetical : 'Parenthetical',
            shot : 'Shot',
            transition : 'Transition',
        }[block.type];

        paragraphType = paragraphType?paragraphType:'Action';

        contentElements.push(ele({
                tag : 'Paragraph',
                a_Type : paragraphType,
                id : nextId++,            
        }).children([
            ele({
                tag : 'Text',
                text : block.text,
            })
        ]));

    });

//  <FinalDraft DocumentType="Script" Template="No" Version="6">
//  <Content></Content>

    var finalDraftElement = ele({
        tag : "FinalDraft",
        a_DocumentType : 'Script',
        a_Template : "No",
        a_Version : 6
    }).children([
        ele("Content").children(contentElements)
    ])

    var finalDraftXml = '<?xml version="1.0" encoding="UTF-8" standalone="no" ?>\n' + finalDraftElement.render();
    
    showDialog({
        title : "Final Draft XML",
        cancel : 'Close',
        message : {tag : 'textarea' , props : {rows: 30,value:finalDraftXml, style:{width:'100%'}}}
    })

}
